import { X } from 'lucide-react';
import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  setAllColumnsVisibility,
  toggleColFilter,
  toggleColumnVisibility,
} from '../../store/slices/filterOptionsSlice';

function ColumnDropDown() {
  const visibleColumns = {};

  const colref = useRef();
  const activeTab = useSelector(
    (state) => state.candidateManagementSlice.activeTab,
  );
  const activeSubTab = useSelector(
    (state) => state.candidateManagementSlice.activeSubTab,
  );
  const currentCols = useSelector(
    (state) => state.filterSlice.columnVisibility?.[activeTab]?.[activeSubTab],
  );

  const isColFilterOpen = useSelector(
    (state) => state.filterSlice.isColFilterOpen,
  );

  console.log({ currentCols });
  const dispatch = useDispatch();

  const handleColumnToggle = (label) => {
    dispatch(
      toggleColumnVisibility({
        tab: activeTab,
        subTab: activeSubTab,
        label,
      }),
    );
  };

  const handleSelectAllColumns = () => {
    dispatch(
      setAllColumnsVisibility({
        subTab: activeSubTab,
        tab: activeTab,
        value: true,
      }),
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (colref.current && !colref.current.contains(event.target)) {
        dispatch(toggleColFilter());
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dispatch]);

  const MANDATORY_COLS = {
    ALL:[
      'Candidate Name',
      'Email Id',
      'Contact Number',
      'Resume Score',
    ],
    MY_UPLOADS: [
      'Candidate Name',
      'Email Id',
      'Contact Number',
      'Resume Score',
    ],
    SOURCED_CANDIDATES: [
      'Candidate Name',
      'Email Id',
      'Contact Number',
      'Resume Score',
    ],
    // No resume score on an outreached candidate, so it can't be mandatory here.
    OUTREACHED: ['Candidate Name', 'Email Id', 'Contact Number'],
    SCHEDULED: ['Candidate Name', 'Email Id', 'Contact Number', 'Status'],
    PROGRESS: ['Candidate Name', 'Email Id', 'Contact Number'],
    COMPLETED: ['Candidate Name', 'Email Id', 'Contact Number'],
    ACCEPTED: ['Candidate Name', 'Email Id', 'Contact Number', 'Status'],
    REJECTED: ['Candidate Name', 'Email Id', 'Contact Number', 'Status'],
  };

  return (
    <div className=" relative transition-all duration-200 bg-red-400">
      {isColFilterOpen && (
        <div
          className="absolute z-[99999] right-6 -top-2 mt-2 min-w-fit border border-gray-600 rounded-lg shadow-sm dark:shadow-lg   p-6 dark:bg-[linear-gradient(233.57deg,rgba(34,52,97,0.25)_-5.01%,rgba(11,10,31,0.05)_100%)] bg-bgPrimary [backdrop-filter:blur(500px)] w-[20%]"
          ref={colref}
        >
          <div className="absolute -top-[9px] right-3 w-4 h-4 rotate-45 
            border-l border-t border-gray-600 
            dark:bg-[#0b0b1f] bg-bgPrimary">
          </div>
          <div className="flex items-center justify-between mb-4 ">
            <h3 className="text-lg font-medium dark:text-[#D9D9D9] text-textPrimary">
              Columns
            </h3>
            <button
              onClick={() => dispatch(toggleColFilter())}
              className="dark:text-gray-400 text-textSecondary dark:hover:text-white hover:text-gray-400"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
          <div className="flex flex-col gap-2">
            <div className="flex space-x-3 mb-4">
              <button
                onClick={handleSelectAllColumns}
                className="flex-1 px-2 py-1 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-full text-xs hover:opacity-90"
              >
                Select All
              </button>
            </div>
            {currentCols.map((colObj, index) => {
              const label = Object.keys(colObj)[0];
              const isChecked = colObj[label];
              const isMandatory = MANDATORY_COLS[activeSubTab]?.includes(label);

              return (
                !isMandatory && <label
                  key={label}
                  className={`flex items-center text-sm dark:text-[#D8D8D8] text-textSecondary
        ${isMandatory ? 'cursor-not-allowed opacity-60 select-none' : 'cursor-pointer'}`}
                >
                  <input
                    type="checkbox"
                    checked={isMandatory ? true : isChecked}
                    disabled={isMandatory}
                    onChange={() => {
                      if (isMandatory) return; // ✅ extra safety guard
                      handleColumnToggle(label);
                    }}
                    className={`mr-2 accent-blue-500 ${isMandatory ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                  />
                  {label}
                  {isMandatory && (
                    <span className="ml-1 text-[10px] text-gray-400">
                      (Required)
                    </span>
                  )}
                </label>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default ColumnDropDown;
